import { POLICY_HUB_URL } from '../env';
import { openPendingNewTab } from './browserNavigation';

const buildPolicyUrl = (options = {}) => {
  const {
    landingRoute = '/',
    suggestedTitle,
    suggestedTags,
  } = options;

  const baseUrl = POLICY_HUB_URL.endsWith('/') ? POLICY_HUB_URL.slice(0, -1) : POLICY_HUB_URL;
  let finalLandingRoute = landingRoute.startsWith('/') ? landingRoute : `/${landingRoute}`;

  if (suggestedTitle || (suggestedTags && suggestedTags.length > 0)) {
    const params = new URLSearchParams();
    if (suggestedTitle) params.append('title', suggestedTitle);
    if (suggestedTags?.length > 0) params.append('tags', suggestedTags.join(','));

    const queryString = params.toString();
    if (queryString) {
      finalLandingRoute = `${finalLandingRoute}${finalLandingRoute.includes('?') ? '&' : '?'}${queryString}`;
    }
  }

  return `${baseUrl}${finalLandingRoute}`;
};

/**
 * Launch the external Policy module through the standard shared-identity flow.
 *
 * The blank tab is opened synchronously from the click handler before any future
 * async work can cause Safari to classify the navigation as a popup.
 */
export const launchPolicyBuilder = async (_user, _organizationId, options = {}) => {
  const { onPopupBlocked, ...policyOptions } = options;
  const pendingTab = openPendingNewTab({
    loadingMessage: 'Opening PolicyHQ...',
    onBlocked: onPopupBlocked || (() => window.alert('Your browser blocked the new tab. Opening PolicyHQ in this tab instead.')),
  });

  try {
    const finalUrl = buildPolicyUrl(policyOptions);
    pendingTab.navigate(finalUrl);
  } catch (err) {
    pendingTab.close();
    console.error('Policy module launch failed:', err);
    throw err;
  }
};
